import Base from './SkeletonBase';
import Text from './TextSkeleton';
import Button from './ButtonSkeleton';
import Circle from './CircleSkeleton';

export default {
  Block: Base,
  Text,
  Button,
  Circle,
};
